var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m49.431 258 35.334-32.666c41.332 20 67.545 35.217 114 68.333 87.334-99.109 145.041-149.39 252.307-216.128l11.498 26.447c-88.457 77.195-153.244 163.178-246.533 330.475C158.499 366.696 120.097 323.5 49.431 258z"
  })));
};

export default SvgCheckMark;